import useLastIdByPage from "./useLastIdByPage";
import usePageLogUpdatedPriceContext from "./usePageLogUpdatedPriceContext";

const usePagination = () => {
  const { isLastPage, perPage, page, loader, items } =
    usePageLogUpdatedPriceContext();
  const { lastId, lastIdInPrevPage } = useLastIdByPage();
  return {
    page: page.value,
    perPage: perPage.value,
    updatePage: (newPage: number) => {
      console.log({ page: newPage, lastId, lastIdInPrevPage });
      loader({
        lastId: newPage > page.value ? lastId : lastIdInPrevPage,
        page: newPage,
      }).then((list) => {
        if (list !== false) {
          page.update(newPage);
        }
      });
    },
    updatePerPage: (newPerPage: number) => {
      perPage.update(newPerPage);
      page.update(0);
    },
    isLastPage: isLastPage.value,
  };
};

export default usePagination;
